import React from 'react';
export function ConfirmEmailTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-375">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-376">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-377" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-378">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-379">
          Confirm your email address
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-380">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-381">
          Thank you for signing up for Aisco Workspace. To complete your
          registration and activate your account, please confirm your email
          address by clicking the button below.
        </p>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-382">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-383">
            Confirm email address
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '8px'
      }} data-id="element-384">
          If you didn't create an account with Aisco Workspace, you can safely
          ignore this message.
        </p>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginBottom: '0'
      }} data-id="element-385">
          This link will expire in 24 hours.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-386">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-387">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-388" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}